$( document ).ready(function() {
    var checkExist = setInterval(function() {
        var $item = $('[data-cf-form] .cf-field:not(.c-pop-up-book-now__bottom--form-field)');
        if ($item.length) {
           clearInterval(checkExist);
            $('.c-password-page__form').show();

            $('.cf-field:not(.c-pop-up-book-now__bottom--form-field)').append('<div class="input__box"></div>');
            $('.cf-field:not(.c-pop-up-book-now__bottom--form-field):not([data-cf-field-type="date"])').each(function(){
                var $label = $(this).find('label');
                var $input = $(this).find('input');
                var $inputBox = $(this).find('.input__box');
                $inputBox.append($input);
                $inputBox.append($label);
                var $dataID = $(this).data('cf-field-id');
                $('.cf-field[data-cf-field-type="checkbox"]').find('label.cf-enum-field__choice').attr('for',$dataID);
                $('.cf-field[data-cf-field-type="email_marketing_consent"]').find('label.cf-enum-field__choice').attr('for',$dataID);
                $('.cf-field[data-cf-field-type="email_marketing_consent"] input[type="checkbox"]').attr('required','')
            })

            $('[name="privacy_policy_1"]').change(function(e) {
              $('input[name="email_marketing_consent"]').val(e.target.value);
            })

            $('select[placeholder="Day"] option').first().text('DD');
            $('select[placeholder="Month"] option').first().text('MM');
            $('select[placeholder="Year"] option').first().text('YY');

            $('select[placeholder="Day"]').parents('.cf-select-wrap').append('<label>DD*</label>');
            $('select[placeholder="Month"]').parents('.cf-select-wrap').append('<label>MM*</label>');
            $('select[placeholder="Year"]').parents('.cf-select-wrap').append('<label>YYYY*</label>');
          /*
            var buttonSubmitText = $('button.cf-submit-form.cf-button.btn.button span').text();
            buttonSubmitText = '<button class="button-cf-submit" type="submit">'+buttonSubmitText+'</button>';
            
            $('.cf-field[data-cf-field-type="email"]').append('<div class="email__box"></div>');
            $('.cf-field[data-cf-field-type="email"] .email__box').append($('.cf-field[data-cf-field-type="email"] .input__box'));
            $('.cf-field[data-cf-field-type="email"] .email__box').append(buttonSubmitText); */

            $policyText = $('.cf-field-description').html();
            $('.cf-enum-field__choice span').html($policyText);
            $('.cf-field-description').remove();

            $('.button-cf-submit').click(function(){
                if(!$('.cf-field-errors.is-shown').length){
                    var checkErrorList = setInterval(function(){
                        var $error = $('.cf-error-message div[data-reach-alert="true"]');
                        if($error.length){
                            clearInterval(checkErrorList);

                            if($error.parents('.cf-error-message').find('.cf-field-errors').length >= 2){
                                $('.cf-form-errors div[data-reach-alert="true"] li').remove();
                                $('.cf-field-errors.is-shown').remove();
                                $('.cf-field-error-list').append(`
                                    <div class="cf-field-errors is-shown"><b>Please fill all mandatory fields to proceed further</b></div>
                                `);
                            }else{
                                var $checkEmailString = '';
                                $checkEmailString = $error.parents('.cf-error-message').find('li').text();
                                if($checkEmailString.indexOf('Please enter valid email id') != -1){
                                    $('.cf-form-errors div[data-reach-alert="true"] li').remove();
                                    $('.cf-field-error-list .cf-field-errors.is-shown').remove();
                                    $('.cf-field-error-list').append(`
                                        <div class="cf-field-errors d-none"><b>Please enter valid email id</b></div>
                                    `);
                                    $('.cf-field-error-list .cf-field-errors:last-child').addClass('is-shown');
                                } 
                                else if($checkEmailString.indexOf('Email has already been taken') != -1){
                                    if($('.cf-field-error-list').length){
                                        $('.cf-form-errors div[data-reach-alert="true"] li').remove();
                                        $('.cf-field-error-list .cf-field-errors.is-shown').remove();
                                        $('.cf-field-error-list').append(`
                                            <div class="cf-field-errors d-none"><b>Please fill all mandatory fields to proceed further</b></div>
                                        `);
                                        $('.cf-field-error-list .cf-field-errors:last-child').addClass('is-shown');
                                    }else{
                                        $('.cf-form-errors div[data-reach-alert="true"] li').remove();
                                        $('.cf-form-errors div[data-reach-alert="true"] li.is-shown').remove();
                                        $('.cf-form-errors div[data-reach-alert="true"]').append(`<li><b>Email has already been taken</b></li>`);
                                        $('.cf-form-errors div[data-reach-alert="true"] li:last-child').addClass('is-shown');
                                    }
                                }
                                else if($checkEmailString.indexOf('Email address is invalid') != -1){
                                    if($('.cf-field-error-list').length){
                                        $('.cf-form-errors div[data-reach-alert="true"] li').remove();
                                        $('.cf-field-error-list .cf-field-errors.is-shown').remove();
                                        $('.cf-field-error-list').append(`
                                            <div class="cf-field-errors d-none"><b>Please fill all mandatory fields to proceed further</b></div>
                                        `);
                                        $('.cf-field-error-list .cf-field-errors:last-child').addClass('is-shown');
                                    }else{
                                        $('.cf-form-errors div[data-reach-alert="true"] li').remove();
                                        $('.cf-form-errors div[data-reach-alert="true"] li.is-shown').remove();
                                        $('.cf-form-errors div[data-reach-alert="true"]').append(`<li><b>Please enter valid email id</b></li>`);
                                        $('.cf-form-errors div[data-reach-alert="true"] li:last-child').addClass('is-shown');
                                    }
                                }
                                else{
                                    $('.cf-form-errors').remove();
                                    $('.cf-form-errors div[data-reach-alert="true"] li').remove();
                                    $('.cf-field-error-list .cf-field-errors.is-shown').remove();
                                    $('.cf-field-error-list').append(`
                                        <div class="cf-field-errors d-none"><b>Please fill all mandatory fields to proceed further</b></div>
                                    `);
                                    $('.cf-field-error-list .cf-field-errors:last-child').addClass('is-shown');
                                }
                            }

                        }
                        else if($('.cf-verify-email-message').length){
                            clearInterval(checkErrorList);
                            $('.cf-verify-email-message div').html(`Thank you,<br>we will keep you updated!`);
                        }
                    },100)
                }
            })
        }
    }, 100); // check every 100ms
});